export default __webpack_public_path__ + "static/media/pow-4-thumb.82def061.jpg";